import { useEffect, useState } from "react";
import { formatToDate } from "../master/FormatToDateTime";
import { dayWiseAttendanceList } from "../../api/BusStudentAttendance";
import { formatDateTime, LoadingDiv, SweetAlertShow } from "../master/Master";
import Nav from "../master/NavBar";
import Header from "../master/SideBar";

export default function BusStudentAttendanceList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({});
  const date = formatToDate(new Date());

  const getList = async () => {
    setLoading(true);
    try {
      let addUrl = "";
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value) {
          addUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      });

      const response = await dayWiseAttendanceList(addUrl);
      if (response?.data?.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, [filters]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="row g-3">
                      <h4 className="mb-0">Attendance List</h4>
                    </div>
                    <hr />
                    <div className="row g-2">
                      <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            value={filters.search}
                            onChange={(e) =>
                              setFilters({ ...filters, search: e.target.value })
                            }
                          />
                          <label htmlFor="">Search</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-hover text-center">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Date</th>
                            <th>Check In </th>
                            <th>Check Out</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.map((item, i) => (
                            <tr>
                              <td>{i + 1}</td>
                              <td>
                                {item?.student_info?.name}(
                                {item?.student_info?.registration_no})
                              </td>
                              <td>{item?.student_info?.phone}</td>
                              <td>{date}</td>
                              <td>{formatDateTime(item?.in_datetime)}</td>
                              <td>{formatDateTime(item?.out_datetime)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
